import { Navigate, useLocation } from 'react-router-dom';
import { useRecoilValue } from 'recoil';
import { isLoggedInAtom } from '@/state/loginState';
import { getCookie } from '@/common/cookie';

interface ProtectedRouteProps {
    children: React.ReactNode;
}

const ProtectedRoute = ({ children }: ProtectedRouteProps) => {
    const isLoggedIn = useRecoilValue(isLoggedInAtom);
    const location = useLocation();
    const hasCookie = !!getCookie('MAC');

    if (!isLoggedIn && !hasCookie) {
        const returnUrl = encodeURIComponent(location.pathname + location.search);
        return <Navigate to={`/login?returnUrl=${returnUrl}`} replace />;
    }

    return <>{children}</>;
};

export default ProtectedRoute;
